import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const noteCardVariants = cva(
  "bg-white rounded-xl border border-gray-200 p-4 hover:shadow-lg transition-shadow duration-200"
);

const categoryVariants = {
  product: "bg-green-100 text-green-700 border-green-200",
  marketing: "bg-blue-100 text-blue-700 border-blue-200",
  development: "bg-purple-100 text-purple-700 border-purple-200",
  design: "bg-pink-100 text-pink-700 border-pink-200",
  business: "bg-orange-100 text-orange-700 border-orange-200",
};

export const NoteCard = React.forwardRef(({
  className,
  title,
  description,
  category = "product",
  author,
  lastUpdated,
  comments = 0,
  icon = "fa-solid fa-note-sticky",
  ...props
}, ref) => {
  return (
    <div
      ref={ref}
      className={cn(noteCardVariants(), className)}
      {...props}
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <i className={cn(icon, "text-green-600")} />
          <span className="text-sm font-medium text-gray-900">Note</span>
        </div>
        <span className={cn(
          "px-2 py-1 text-xs font-medium rounded border",
          categoryVariants[category] || categoryVariants.product
        )}>
          {category.charAt(0).toUpperCase() + category.slice(1)}
        </span>
      </div>

      {/* Content */}
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900 mb-2">
          {title}
        </h3>
        <p className="text-xs text-gray-600 leading-relaxed">
          {description}
        </p>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between">
        {/* Author */}
        <div className="flex items-center space-x-2">
          {author?.avatar ? (
            <img
              src={author.avatar}
              alt={author.name}
              className="w-6 h-6 rounded-full"
            />
          ) : (
            <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center">
              <span className="text-xs font-medium text-gray-600">
                {author?.name?.charAt(0) || '?'}
              </span>
            </div>
          )}
          <span className="text-xs text-gray-600">
            {lastUpdated}
          </span>
        </div>

        {/* Comments */}
        {comments > 0 && (
          <div className="flex items-center space-x-1 text-xs text-gray-600">
            <i className="fa-solid fa-comment" />
            <span>{comments}</span>
          </div>
        )}
      </div>
    </div>
  );
});

NoteCard.displayName = "NoteCard"; 